import RiskCard from './RiskCard'

const RISKS = [
  { key: 'inondation_ppr', title: 'Inondation — Zones PPR', rapportKey: 'risquesNaturels.inondation' },
  { key: 'inondation_tri', title: 'Inondation — TRI', rapportKey: 'risquesNaturels.inondation' },
  { key: 'argiles', title: 'Retrait-gonflement des argiles', rapportKey: 'risquesNaturels.retraitGonflementArgile' },
  { key: 'mouvements_terrain', title: 'Mouvements de terrain', rapportKey: 'risquesNaturels.mouvementTerrain' },
  { key: 'cavites', title: 'Cavités souterraines', rapportKey: 'risquesNaturels.mouvementTerrain' },
  { key: 'sismicite', title: 'Sismicité', rapportKey: 'risquesNaturels.seisme' },
  { key: 'radon', title: 'Potentiel radon', rapportKey: 'risquesNaturels.radon' },
  { key: 'icpe', title: 'Installations classées (ICPE)', rapportKey: 'risquesTechnologiques.icpe' },
  { key: 'sols_pollues', title: 'Sites et sols pollués', rapportKey: 'risquesTechnologiques.pollutionSols' },
  { key: 'avalanches', title: 'Avalanches', rapportKey: 'risquesNaturels.avalanche' },
]

export default function RiskGrid({ cartes, risquesRapport }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {RISKS.map((risk) => (
        <RiskCard
          key={risk.key}
          title={risk.title}
          imageUrl={cartes?.[risk.key]}
          rapport={risquesRapport}
          rapportKey={risk.rapportKey}
        />
      ))}
    </div>
  )
}
